angular
    .module('MW.ContactManager.CsvSelector', [])
    .directive('csvSelector', [function() {
        'use strict';

        return {
            restrict: 'E',
            scope: {
                selectedFileCallback: '&?'
            },
            link: function(scope, element) {
                var hiddenSelectorElement = element.find('.hiddenSelector'),
                    selectedFileElement = element.find('.selectedFile'),
                    selectorButtonElement = element.find('.selector');

                selectorButtonElement.on('click', function() {
                    hiddenSelectorElement[0].click();
                });

                // when the file changes, update the preview
                hiddenSelectorElement.on('change', function() {
                    var selectedFile = hiddenSelectorElement[0].files[0];

                    if (selectedFile) {
                        selectedFileElement.val(selectedFile.name);
                    }

                    // check to see if we have a callback to pass the result to
                    if(scope.selectedFileCallback && typeof scope.selectedFileCallback === 'function') {
                        scope.selectedFileCallback({fileContents: selectedFile});
                    }
                });

                scope.$on('$destroy', function onDestroy() {
                    selectorButtonElement.off('click');
                    hiddenSelectorElement.off('change');
                });
            },
            templateUrl: 'icm-web/views/partials/csv_selector'
        };
    }]);